import { render, staticRenderFns } from "./VehicleStatus.vue?vue&type=template&id=71a4484c&scoped=true&"
import script from "./VehicleStatus.vue?vue&type=script&lang=js&"
export * from "./VehicleStatus.vue?vue&type=script&lang=js&"
import style0 from "./VehicleStatus.vue?vue&type=style&index=0&id=71a4484c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a4484c",
  null
  
)

export default component.exports